<main>
  @if (isInDrawerMode) {
    <div>
      <div class="drawer-bar">
        <div class="drawer-sub-header">
          <app-breadcrumb
            [elements]="[{ text: ('expenseAdd' | translate), title: '' }]"
          ></app-breadcrumb>
        </div>
      </div>
    </div>
  }

  <div class="content-container">
    @if (!isDrawerOpened) {
      <app-error-form
        [errorMessage]="errorMessage"
        [validationErrorMessages]="validationErrorMessages"
      ></app-error-form>
    }
    <div class="flex flex-col gap-6">
      <kendo-card>
        <form [formGroup]="form">
          <div class="flex items-center gap-6">
            <h1 class="flex-1 m-0 pb-3 text-[20px] font-medium text-black">
              {{ "expenseAdd" | translate }}
            </h1>
            <div class="flex items-center justify-center">
              <app-actions-dropdown
                [data]="actionMenuOptions"
                (itemClick)="openCurrencyInfoAddDrawer()"
              ></app-actions-dropdown>
            </div>
          </div>
          <section class="flex gap-[1.6rem]">
            <div class="flex-col basis-[50%] flex gap-4">
              <kendo-formfield>
                <kendo-label text="{{ 'reference' | translate }}">
                  <kendo-textbox formControlName="reference"></kendo-textbox>
                </kendo-label>
                @if (
                  form.controls.reference.errors?.required && showValidation
                ) {
                  <kendo-formerror>{{
                    "referenceIsRequired" | translate
                  }}</kendo-formerror>
                }
              </kendo-formfield>
              <app-contacts-dropdown
                [parentForm]="form"
                title="{{ 'vendor' | translate }}*"
                [controlName]="'vendor'"
                [valuePrimitive]="false"
                createKey="Supplier"
                [filter]="contactFilter"
                (customerSelect)="sendCustomerToEditContact($event)"
              >
              </app-contacts-dropdown>
              <app-accounts-dropdown
                [parentForm]="form"
                [mode]="'paymentAccountUid'"
                [controlName]="'paymentAccountUid'"
                title="{{ 'paidFromAccount' | translate }}*"
                [filter]="accountFilter"
                (valueChange)="createJournalEntryItems()"
              ></app-accounts-dropdown>
            </div>
            <div class="flex-col basis-[50%] flex gap-4">
              <app-date-calendar
                title="{{ 'date' | translate }}*"
                [parentForm]="form"
                [controlName]="'date'"
                [showValidation]="showValidation"
              >
              </app-date-calendar>
              @if (isCompanyProjectLinked) {
                <app-company-project-dropdown
                  [parentForm]="form"
                  controlName="projectUid"
                ></app-company-project-dropdown>
              }
              @if (allowMultiCurrency) {
                <app-currency-dropdown
                  [parentForm]="form"
                  controlName="currencyUid"
                  [loadDefaultValue]="true"
                  settingKey="defaultExpenseCurrency"
                >
                  @if (
                    form.controls.currencyUid.errors?.required && showValidation
                  ) {
                    <kendo-formerror>{{
                      "currencyIsRequired" | translate
                    }}</kendo-formerror>
                  }
                </app-currency-dropdown>
              }
              <!-- Related to Currency Dropdown, to fetch the latest rate, based on selected currency -->
              <app-currency-rate-input
                [hidden]="true"
                [parentForm]="form"
              ></app-currency-rate-input>
            </div>
          </section>
          <div class="flex-row">
            <app-editing-contact
              (sendSalesman)="onVendorReceived($event)"
              [contactEvent]="sendCustomer.asObservable()"
            ></app-editing-contact>
          </div>
        </form>
      </kendo-card>
      <kendo-card>
        <kendo-tabstrip [keepTabContent]="true" class="mt-0">
          <kendo-tabstrip-tab
            title="{{ 'expenses' | translate }}"
            [selected]="true"
          >
            <ng-template kendoTabContent>
              <section>
                <app-expenses-editable-grid
                  #expensesEditableGrid
                  [parentForm]="form"
                  [budgetItems]="budgetItems"
                  (formChanged)="createJournalEntryItems()"
                  (rowRemoved)="createJournalEntryItems()"
                  (checkDirty)="dirtyFormHandler($event)"
                ></app-expenses-editable-grid>
              </section>
            </ng-template>
          </kendo-tabstrip-tab>
          <!-- FIXME -->
          <!-- <kendo-tabstrip-tab title="Journals">
              <ng-template kendoTabContent>
                <section>
                  <app-journal-grid></app-journal-grid>
                </section>
              </ng-template>
            </kendo-tabstrip-tab> -->
        </kendo-tabstrip>
      </kendo-card>
    </div>
  </div>

  <app-action-bar
    [isBoxShadow]="false"
    [isWaiting]="isWaiting"
    [screenType]="'Form'"
    [actionsOptions]="[
      {
        visible: true,
        class: 'btn-primary',
        label: 'Save and Close',
        labelName: ('saveAndClose' | translate),
        options: !isInDrawerMode
          ? [{ text: ('saveAndNew' | translate), value: 'Save and New' }]
          : null
      },
      {
        visible: true,
        class: 'btn-outline-secondary',
        label: 'Discard',
        labelName: ('discard' | translate)
      }
    ]"
    (buttonClick)="onActionClick($event, 'add')"
  >
  </app-action-bar>
</main>
